import styled from "styled-components";

import { DaysStyledProps as Props } from "./Days.types";

const DaysStyled = styled.div<Props>`
  display: flex;
  flex-direction: row;
  padding: 2rem;
  background-color: var(--palette-mid-blue-s13-l18);
  border-radius: 2.4rem;
  align-items: center;

  .Days {
    &__slider {
      max-width: 72rem;
      height: 8rem;
    }

    &__left-arrow {
      cursor: pointer;
      padding: 0.8rem;
    }

    &__right-arrow {
      cursor: pointer;
      padding: 3.2rem 2rem;
      background-color: var(--palette-mid-blue-s13-l18);
    }
  }

  .Slider {
    overflow: hidden;

    .slick-prev::before {
      display: none !important;
    }

    .slick-prev {
      left: 0;
      top: 3.2rem;
    }

    .slick-next::before {
      display: none !important;
    }

    .slick-next {
      right: 1.6rem;
      top: 0.8rem;
    }

    .slick-list {
      padding: 0 3.2rem;
    }
  }
`;

export default DaysStyled;
